import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthrized',
  templateUrl: './unauthrized.component.html',
  styleUrls: ['./unauthrized.component.css']
})
export class UnauthrizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
